import AllCoachesReportContent from '/component/partial/reportCard/AllCoachesReportContent';
import CloseToExecutiveDirectorReportContent from '/component/partial/reportCard/CloseToExecutiveDirectorReportContent';
import CloseToFibcReportContent from '/component/partial/reportCard/CloseToFibcReportContent';
import CloseToSeniorCoachReportContent from '/component/partial/reportCard/CloseToSeniorCoachReportContent';
import {CoachSearchContent} from '/component/partial/reportCard/CoachSearchContent';
import {EarnedCabReportContent} from '/component/partial/reportCard/EarnedCabReportContent';
import {EarnedCoachAcceleratorBonusReportContent} from '/component/partial/reportCard/EarnedCoachAcceleratorBonusReportContent';
import {EarnedCSBPlusReportContent} from '/component/partial/reportCard/EarnedCSBPlusReportContent';
import {EarnedQsbReportContent} from '/component/partial/reportCard/EarnedQsbReportContent';
import {EligibleAcceleratorBonusReportContent} from '/component/partial/reportCard/EligibleAcceleratorBonusReportContent';
import {EligibleClientSupportBonusPlusReportContent} from '/component/partial/reportCard/EligibleClientSupportBonusPlusReportContent';
import {EligibleForCabReportContent} from '/component/partial/reportCard/EligibleForCabReportContent';
import {EligibleForIncentiveTripReportContent} from '/component/partial/reportCard/EligibleForIncentiveTripReportContent';
import {EligibleForQsbReportContent} from '/component/partial/reportCard/EligibleForQsbReportContent';
import EmptyReportContent from '/component/partial/reportCard/EmptyReportContent';
import ExpiringCoachRenewalsReportContent from '/component/partial/reportCard/ExpiringCoachRenewalsReportContent';
import NewCoachesReportContent from '/component/partial/reportCard/NewCoachesReportContent';
import PromotionReportContent from '/component/partial/reportCard/PromotionReportContent';
import {QualifiedForIncentiveTripReportContent} from '/component/partial/reportCard/QualifiedForIncentiveTripReportContent';
import TeamRankReportContent from '/component/partial/reportCard/TeamRankReportContent';
import {
  REPORT_CARD_CONTENT_ALL_COACHES,
  REPORT_CARD_CONTENT_CLOSE_TO_ED,
  REPORT_CARD_CONTENT_CLOSE_TO_FIBC,
  REPORT_CARD_CONTENT_CLOSE_TO_SC,
  REPORT_CARD_CONTENT_EARNED_CAB,
  REPORT_CARD_CONTENT_EARNED_QSB,
  REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB,
  REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB,
  REPORT_CARD_CONTENT_EMPTY,
  REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL,
  REPORT_CARD_CONTENT_NEW_COACHES,
  REPORT_CARD_CONTENT_PROMOTION,
  REPORT_CARD_CONTENT_TEAM_RANK,
  REPORT_CARD_EARNED_ACCELERATOR_BONUS,
  REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP,
  REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP,
  SEARCH_CARD_COACHES_CONTENT,
} from '/enum/reportCard.enum';

export const ALL_CONTENT = {
  [REPORT_CARD_CONTENT_PROMOTION]: PromotionReportContent,
  [REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB]: EligibleForCabReportContent,
  [REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS]:
    EligibleAcceleratorBonusReportContent,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR]:
    EligibleClientSupportBonusPlusReportContent,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS]:
    EligibleClientSupportBonusPlusReportContent,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX]:
    EligibleClientSupportBonusPlusReportContent,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO]:
    EligibleClientSupportBonusPlusReportContent,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE]:
    EligibleClientSupportBonusPlusReportContent,
  [REPORT_CARD_EARNED_ACCELERATOR_BONUS]:
    EarnedCoachAcceleratorBonusReportContent,
  [REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS]: EarnedCSBPlusReportContent,
  [REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB]: EligibleForQsbReportContent,
  [REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL]:
    ExpiringCoachRenewalsReportContent,
  [REPORT_CARD_CONTENT_TEAM_RANK]: TeamRankReportContent,
  [REPORT_CARD_CONTENT_ALL_COACHES]: AllCoachesReportContent,
  [REPORT_CARD_CONTENT_NEW_COACHES]: NewCoachesReportContent,
  [REPORT_CARD_CONTENT_CLOSE_TO_SC]: CloseToSeniorCoachReportContent,
  [REPORT_CARD_CONTENT_CLOSE_TO_ED]: CloseToExecutiveDirectorReportContent,
  [REPORT_CARD_CONTENT_CLOSE_TO_FIBC]: CloseToFibcReportContent,
  [REPORT_CARD_CONTENT_EARNED_CAB]: EarnedCabReportContent,
  [REPORT_CARD_CONTENT_EARNED_QSB]: EarnedQsbReportContent,
  [REPORT_CARD_CONTENT_EMPTY]: EmptyReportContent,
  [SEARCH_CARD_COACHES_CONTENT]: CoachSearchContent,
  [REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP]:
    EligibleForIncentiveTripReportContent,
  [REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP]:
    QualifiedForIncentiveTripReportContent,
};
